export const dialogContainer =
  'h-full bg-white flex flex-1 flex-col bg-primaryAccent1';
export const buttonIcon = 'h-4 w-4 text-white mr-2';
export const labelContainer =
  'flex flex 1 flex-row justify-between items-center mb-6 pt-2';
export const dialogContent = 'h-full overflow-y-hidden';
